import { Platform } from 'react-native';
import { ROUTE } from "../../routes";
import { fetchLinkRepo } from "../loanAgreement/loan_agreement/repo";
import { APP_CONFIG, getAppHeader, } from '../../configs/config';
import { POPUP_TARGET_NAME } from '../../configs/constants';
import AsyncStorage from '@react-native-async-storage/async-storage';
import SharedPropsService from '../../SharedPropsService';
import { api } from '../../configs/api';
import { getParameters, nextStepCredStepper } from '../../configs/utils';
var popupOpened;
let url = '';
let route = "";
let resetAgreementCall = false;
let counter = 0;
let stepResponseObject;
export const continueAction = async (action, datastore, { removeWidgets, navigateWithClear }) => {
    await navigateWithClear(ROUTE.BAJAJ_KFS);
};
export const agreementAction = async (action, datastore, { network, navigate, analytics, setDatastore }) => {
    await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
        loading: true
    });
    const responseX = await fetchLinkRepo();
    const urlData = responseX.stepResponseObject;
    if (responseX.status !== 'SUCCESS') {
        navigate(ROUTE.LOAN_AGREEMENT_POLLING);
    }
    else {
        url = urlData;
        resetAgreementCall = false,
            await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
                showClickForAgreementCard: true,
                showNewAgreementFlow: true,
                loading: false,
            });
    }
};
export const goToAgreementPage = async (action, datastore, { setDatastore }) => {
    resetAgreementCall = true;
    if (popupOpened) {
        popupOpened.close();
    }
    await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
        showNewAgreementFlow: false,
        showClickForAgreementCard: false,
        loading: false,
        counter: counter++,
    });
};
export const closeFailureCard = async (action, datastore, { setDatastore }) => {
    await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
        showNewAgreementFlow: false,
        showClickForAgreementCard: false,
        showAgreementFailureStatus: false,
        loading: false,
        counter: counter++,
    });
    if (popupOpened) {
        popupOpened.close();
    }
};
export const openLinkInNewTabKfs = async (action, _datastore, { appendWidgets, removeWidgets, openNewTab, hidePopup, showPopup, getHeight, setDatastore, network, ...props }) => {
    await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
        loading: true
    });
    let applicationId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    const kfsResponse = await network.get(`${api.getBajajKfsv2}${applicationId}`, { headers: await getAppHeader() });
    let url = kfsResponse.data.stepResponseObject;
    if (true) {
        if (Platform.OS === 'web') {
            const config = {
                width: 600,
                height: 600,
                target: 'Volt Money',
            };
            const left = screen.width / 2 - config.width / 2;
            const top = screen.height / 2 - config.height / 2;
            popupOpened = window.open(url, POPUP_TARGET_NAME.AGREEMENT, `height=${APP_CONFIG.POP_UP_SIZE.HEIGHT},width=${APP_CONFIG.POP_UP_SIZE.WIDTH}. top=${top}, left=${left}`);
            await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
                showClickForAgreementCard: false,
                showWaitingForResponseCard: true,
                loading: false,
            });
        }
        else {
            await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
                loading: false,
                showWebView: true,
                agreementUrl: url
            });
        }
        await PollKfsStatusAction(action, {}, {
            appendWidgets,
            removeWidgets,
            openNewTab,
            hidePopup,
            showPopup,
            getHeight,
            setDatastore,
            network,
            ...props,
        });
    }
};
export const openLinkInNewTab = async (action, _datastore, { appendWidgets, removeWidgets, openNewTab, hidePopup, showPopup, getHeight, setDatastore, network, ...props }) => {
    //    await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", <BajajAgreementStepperProps>{
    //        loading: true
    //    })
    if (!resetAgreementCall) {
        if (Platform.OS === 'web') {
            const params = getParameters(window.location.href);
            const isFromiOSSDK = params?.isFromiOSSdk;
            const config = {
                width: 600,
                height: 600,
                target: 'Volt Money',
            };
            const left = screen.width / 2 - config.width / 2;
            const top = screen.height / 2 - config.height / 2;
            if (isFromiOSSDK) {
                //  window.open(url,"_parent")
                // @ts-ignore
                window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage(url);
            }
            else {
                popupOpened = window.open(url, POPUP_TARGET_NAME.AGREEMENT, `height=${APP_CONFIG.POP_UP_SIZE.HEIGHT},width=${APP_CONFIG.POP_UP_SIZE.WIDTH}. top=${top}, left=${left}`);
            }
            await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
                showClickForAgreementCard: false,
                // showWaitingForResponseCard: true,
                loading: false,
            });
        }
        else {
            await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
                loading: false,
                showWebView: true,
                agreementUrl: url
            });
        }
        await PollAgreementStatusAction(action, {}, {
            appendWidgets,
            removeWidgets,
            openNewTab,
            hidePopup,
            showPopup,
            getHeight,
            setDatastore,
            network,
            ...props,
        });
    }
};
let hasNavigate = false;
export const backActionAgreement = async (action, _datastore, { navigateWithClear }) => {
    await navigateWithClear(ROUTE.KYC_STEPPER);
};
export const goBackAction = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const kfsSuccessAction = async (action, _datastore, { goBack, navigateToBase }) => {
    await navigateToBase(ROUTE.BAJAJ_AGREEMENT_STEPPER);
};
export const kfsCancelAction = async (action, _datastore, { goBack, setDatastore }) => {
    await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
        showAgreementCompleteStatus: false,
        showClickForAgreementCard: false,
        showWaitingForResponseCard: false,
        showKfsCancelledStatus: false,
        showKfsCompletedStatus: true,
    });
};
export const NavToDashboard = async (action, _datastore, { navigate, goBack, navigateWithClear }) => {
    hasNavigate = true;
    const routeObj = await nextStepCredStepper(route, stepResponseObject);
    await navigateWithClear(routeObj.routeId, routeObj.params);
};
export const PollKfsStatusAction = async (action, _datastore, { network, showPopup, navigateWithClear, setDatastore, removeWidgets, appendWidgets, getHeight }) => {
    let applicationId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    const getApiLoad = async () => {
        if (Platform.OS === "web" && popupOpened.closed) {
            await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
                showAgreementCompleteStatus: false,
                showClickForAgreementCard: false,
                showWaitingForResponseCard: false,
                showKfsCompletedStatus: false,
                showKfsCancelledStatus: false
            });
            clearInterval(timerRef);
        }
        await network
            .get(`${api.getKfsStatusv2}${applicationId}`, {
            headers: await getAppHeader(),
        })
            .then(response => response.data)
            .then(async (response) => {
            if (response.stepResponseObject.toLowerCase() === 'success') {
                clearInterval(timerRef);
                const user = await SharedPropsService.getUser();
                user.linkedApplications[0] = response.updatedApplicationObj;
                await SharedPropsService.setUser(user);
                console.log("DSR HERE: ");
                await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
                    showAgreementCompleteStatus: false,
                    showClickForAgreementCard: false,
                    showWaitingForResponseCard: false,
                    showKfsCancelledStatus: false,
                    showKfsCompletedStatus: true
                });
                if (Platform.OS !== 'web') {
                    await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
                        showWebView: false
                    });
                }
                clearInterval(timerRef);
                if (popupOpened) {
                    popupOpened.close();
                }
            }
            else if (response.stepResponseObject.toLowerCase() === 'failed') {
                if (popupOpened) {
                    popupOpened.close();
                }
                clearInterval(timerRef);
                await setDatastore(ROUTE.LOAN_AGREEMENT, "bajajAgreementStepperDC", {
                    showAgreementCompleteStatus: false,
                    showClickForAgreementCard: false,
                    showWaitingForResponseCard: false,
                    showAgreementFailureStatus: true,
                });
            }
        });
    };
    const timerRef = setInterval(() => {
        getApiLoad();
    }, APP_CONFIG.POLLING_INTERVAL);
};
export const PollAgreementStatusAction = async (action, _datastore, { network, showPopup, navigateWithClear, setDatastore, removeWidgets, appendWidgets, getHeight }) => {
    let applicationId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    const getApiLoad = async () => {
        if (resetAgreementCall) {
            clearInterval(timerRef);
            if (popupOpened) {
                popupOpened.close();
            }
            return;
        }
        await network
            .get(`${api.agreementStatus}${applicationId}`, {
            headers: await getAppHeader(),
        })
            .then(response => response.data)
            .then(async (response) => {
            if (response.stepResponseObject.toLowerCase() === 'success') {
                clearInterval(timerRef);
                if (Platform.OS === 'web') {
                    //@ts-ignore
                    window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closePop");
                }
                const user = await SharedPropsService.getUser();
                user.linkedApplications[0] = response.updatedApplicationObj;
                await SharedPropsService.setUser(user);
                let applicationId;
                if (await AsyncStorage.getItem("application_id") !== null) {
                    applicationId = await AsyncStorage.getItem("application_id");
                }
                else {
                    applicationId = user.linkedApplications[0].applicationId;
                }
                const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
                await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
                    showWebView: false,
                });
                if (popupOpened) {
                    popupOpened.close();
                }
                let routeObj;
                if (await AsyncStorage.getItem("application_id") !== null) {
                    routeObj = await nextStepCredStepper(updatedApplicationResponse.data.currentStepId, updatedApplicationResponse.data.stepStatusMap);
                    await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
                        showAgreementCompleteStatus: true,
                        showClickForAgreementCard: false,
                        showWaitingForResponseCard: false,
                        showNewAgreementFlow: false,
                        routeObj: routeObj
                    });
                    route = updatedApplicationResponse.data.currentStepId;
                    stepResponseObject = updatedApplicationResponse.data.stepStatusMap;
                    setTimeout(() => {
                        !hasNavigate && navigateWithClear(routeObj.routeId, routeObj.params);
                    }, 4000);
                }
                else {
                    const currentStepId = user.linkedApplications[0].currentStepId;
                    routeObj = await nextStepCredStepper(currentStepId);
                    route = updatedApplicationResponse.data.currentStepId;
                    stepResponseObject = updatedApplicationResponse.data.stepStatusMap;
                    await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
                        showAgreementCompleteStatus: true,
                        showClickForAgreementCard: false,
                        showWaitingForResponseCard: false,
                        showNewAgreementFlow: false,
                        routeObj: routeObj
                    });
                    setTimeout(() => {
                        !hasNavigate && navigateWithClear(routeObj.routeId, routeObj.params);
                    }, 4000);
                }
            }
            else if (response.stepResponseObject.toLowerCase() === 'failed') {
                clearInterval(timerRef);
                await setDatastore(ROUTE.BAJAJ_AGREEMENT_STEPPER, "bajajAgreementStepperDC", {
                    showAgreementCompleteStatus: false,
                    showClickForAgreementCard: false,
                    showWaitingForResponseCard: false,
                    showAgreementFailureStatus: true,
                    showNewAgreementFlow: false,
                });
            }
        });
    };
    const timerRef = setInterval(() => {
        getApiLoad();
    }, APP_CONFIG.POLLING_INTERVAL);
};
